import { Button, ButtonThemesEnum } from '@propertyfinder/button';
import { TextField } from '@propertyfinder/text-field';
import { Fragment, FunctionComponent, h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { EligibilityValidationFormTemplatePropsInterface } from 'common/module/property-report/eligibility-validation-form/template-props.interface';

export const EligibilityValidationFormTemplate: FunctionComponent<EligibilityValidationFormTemplatePropsInterface> = ({
  isAgentListing,
  onClick,
  onChange,
  state,
  cmtFieldErrors,
  isValidatingField,
}) => {
  return (
    <Fragment>
      <div className='property-report-2__info row-center'>
        <p className='property-report-2__info--text'>{i18nTranslate('ReportProperty_ProvideEmailHint')}</p>
      </div>

      <div className='property-report-2__input-area'>
        <TextField
          htmlAttributes={{
            type: 'email',
            'data-testid': 'agent-email-input',
          }}
          placeholder={i18nTranslate('Auth_EmailLabel')}
          value={state.agentEmail}
          required
          onInput={(e: InputEvent): void => onChange(e, 'agentEmail')}
          errorText={cmtFieldErrors.agentEmail}
          className={cmtFieldErrors.errorFromServer ? 'property-report-2__input-area--error' : ''}
        />

        {!isAgentListing ? (
          <TextField
            htmlAttributes={{
              type: 'text',
              'data-testid': 'listing-url-input',
            }}
            placeholder={i18nTranslate('ReportProperty_EnterUrlAddress')}
            value={state.listingUrl}
            onInput={(e: InputEvent): void => onChange(e, 'listingUrl')}
            errorText={cmtFieldErrors.listingUrl}
            className={cmtFieldErrors.errorFromServer ? 'property-report-2__input-area--error' : ''}
          />
        ) : null}
        {cmtFieldErrors.errorFromServer && (
          <div className='property-report-2__invalid'>{cmtFieldErrors.errorFromServer}</div>
        )}
      </div>

      <div className='property-report-2__form-submit'>
        <Button
          theme={ButtonThemesEnum.PRIMARY}
          className='property-report-2__form-submit--button'
          onClick={onClick}
          loading={isValidatingField}
        >
          {i18nTranslate('ReportProperty_Validate')}
        </Button>
      </div>
    </Fragment>
  );
};
